export interface ContentBlock{
    id: number;
    content: string;
    displayName: string;
    imageUrl: string;
    header: string;
    icon: string;
}